// generated by genversion
export const version = '2.11.0';
//# sourceMappingURL=version.js.map